import PlanEntryRoadRouteParams from "../../../../common/services/plan-entry/road-route/plan-entry-road-route-params";
import RouteDetailsRouteWaypointGroup from "./types/route-details-route-waypoint-group";

const create = (
  group: RouteDetailsRouteWaypointGroup,
): PlanEntryRoadRouteParams => {
  return {
    waypoints: group.waypoints.map((waypoint) => ({
      lat: waypoint.place.latitude,
      lon: waypoint.place.longitude,
    })),
    excludeHighway: group.excludeHighway,
  };
};

const routeRoadRouteLoadParamsFactory = {
  create,
};

export default routeRoadRouteLoadParamsFactory;
